export class GoogleAddress {
  placeId: string = null;
  description: string = null;

  constructor(obj?: GoogleAddress) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
